import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { LookupResponse } from '@core/models/common.model';
import { CreateDependantRequest, DependantResponse } from '../../employee.model';
import { DependantFormComponent } from '../dependant-form/dependant-form.component';

@Component({
  selector: 'dependant-modal',
  imports: [MatDialogModule, ...SharedMaterialUIModule, DependantFormComponent],
  templateUrl: './dependant-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DependantModalComponent {
  private readonly dialogRef = inject(MatDialogRef<DependantModalComponent>);

  readonly dependantTypes = input<LookupResponse[]>([]);
  readonly titles = input<LookupResponse[]>([]);
  readonly initialValue = input<DependantResponse | null>(null);
  readonly saving = input(false);

  protected onSubmit(request: CreateDependantRequest): void {
    this.dialogRef.close(request);
  }

  protected onCancel(): void {
    this.dialogRef.close();
  }

  protected get title(): string {
    return this.initialValue() ? 'Edit dependant' : 'Create dependant';
  }
}
